import {Component} from '@angular/core';

@Component({
  selector: 'input-number-node',
  templateUrl: './input-number-node.component.html'
})
export class InputNumberNodeComponent {
    node
}
